<template>
    <div class="notifications-container growup">
        <div class="icon-close" @click="$store.dispatch('deleteScore', score)"></div>
        <div class="growup-content" v-if="score.userLevel.new_level">
            <h3>Новый уровень!</h3>
            <p>{{ score.userLevel.level.description }}</p>
        </div>
        <div class="growup-progress">
            <transition name="fade">
                <div class="growup-score">
                    <p>+{{score.newScore.rate}}</p>
                    <img src="@/assets/images/emoji/LoveYouGesture.svg" width="18" />
                </div>
            </transition>
            <div class="growup-avatar" :style="{backgroundImage: `url('${getUser.avatar}')`}">
                <div class="growup-avatar__status">
                    <img :src="require(`@/assets/images/emoji/${score.userLevel.level.icon}.svg`)" width="12" />
                </div>
            </div>
            <div class="growup-progress-line">
                <div class="growup-progress-inside" :style="{width: `${getLineWidth}%`}">
                    <p class="growup-progress__count">{{score.userLevel.sum}}</p>
                </div>
                <p class="growup-progress__count" v-if="getLineWidth < 80">{{score.userLevel.next.score}}</p>
            </div>
            <div class="growup-level new-level" v-if="score.userLevel.new_level">
                <img :src="require(`@/assets/images/emoji/${score.userLevel.level.icon}.svg`)" width="24" />
            </div>
            <div class="growup-level" v-else>
                <img src="@/assets/images/emoji/question.svg" width="34" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'GroupUp',
    data: () => {
        return {
            rate: false
        }
    },
    props: {
        score: {
            type: Object
        }
    },
    computed: {
        getUser() {
            return this.$store.getters.getAuthUser
        },
        getLineWidth() {
            return this.score.userLevel.new_level 
                ? 100
                : this.score.userLevel.sum / (this.score.userLevel.next.score / 100)
        }
    },
    mounted() {
        setTimeout(() => this.rate = true)
    }
}
</script>
<style lang="stylus">
    .growup
        padding 25px
        width 350px
        +to-width(540px)
            width 100%
        &-content
            h3
                text-align center
                font-size 18px
                padding-bottom 5px
        &-score
            display flex
            align-items flex-start
            justify-content center
            font-size 16px
            font-weight 600
            padding-bottom 5px
            img
                margin-left 5px

        &-progress
            width 100%
            position relative
            padding 12px 45px
            padding-top 0px

            &-line
                position relative
                background-color #F9F9F9
                height 26px
                display flex
            
            &-inside
                position relative
                height 100%
                border-radius 0 20px 20px 0px
                width 50%
                background-color #A7E28C
                .growup-progress__count
                    color #82BD66
            
            &__count
                font-size 13px
                font-weight 600
                color #DEDEDE
                position absolute
                right 15px
                top 2px
        &-avatar
            position absolute
            left 0px
            bottom 0
            width 55px
            height 55px
            border-radius 50%
            border 3px solid white
            background-color white
            background-size cover
            background-position center
            z-index 2
            &__status
                position absolute
                right -5px
                top -5px
                width 25px
                height 25px
                border-radius 50%
                background-color white
                display flex
                align-content center
                justify-content center
        
        &-level
            position absolute
            right 0px
            bottom 0
            width 55px
            height 55px
            border-radius 50%
            border 3px solid #A7E28C
            background-color white
            background-size cover
            background-position center
            z-index 2
            display flex
            justify-content center
            align-items center
            &.new-level
                box-shadow 0px 0px 20px rgba(97,233,171,0.5)
                
                &:after
                    content ''
                    position absolute
                    z-index -1
                    top -10px
                    left -10px
                    right -10px
                    bottom -10px
                    background-image url('~@/assets/images/defaults/shine.webp')
                    background-size cover
                    opacity 0.6
                    animation spin 3s linear infinite

@keyframes spin {
    0% {
        transform rotate(0deg)
    }
    100% {
        transform rotate(360deg)
    }
}
</style>